export const CRM_TASKS_RESET_STATE = 'CRM_TASKS_RESET_STATE';
export const CRM_TASKS_CURRENT_ITEM = 'CRM_TASKS_CURRENT_ITEM';

export const CRM_TASKS_REQUEST_LOADING = 'CRM_TASKS_REQUEST_LOADING';
export const CRM_TASKS_REQUEST_SUCCESS = 'CRM_TASKS_REQUEST_SUCCESS';
export const CRM_TASKS_REQUEST_FAILED = 'CRM_TASKS_REQUEST_FAILED';

export const CRM_TASKS_CURRENT_ACTION = 'CRM_TASKS_CURRENT_ACTION';
export const CRM_TASKS_RESET_ACTION = 'CRM_TASKS_RESET_ACTION';